import type { FC } from "react";
import {
  type RouteObject,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { AppLayout } from "@components/AppLayout/AppLayout";
import { ErrorBoundaryWrapper } from "@components/errors/ErrorBoundaryWrapper/ErrorBoundaryWrapper";
import { ErrorNotFound } from "@components/errors/ErrorNotFound/ErrorNotFound";
import { Dashboard } from "@pages/Dashboard/Dashboard";
import { Documents } from "@pages/Documents/Documents";
import { Settings } from "@pages/Settings/Settings";
import { Shield } from "@pages/Shield/Shield";
import { Tickets } from "@pages/Tickets/Tickets";

import { accessManagerRoutes } from "./accessManagerRoutes";
import { loginRoutes } from "./loginRoutes";
import { perimeterRoutes } from "./perimeterRoutes";
import { ROUTES } from "./router.constants";

export const routerConfig: RouteObject[] = [
  {
    errorElement: <ErrorBoundaryWrapper />,
    children: [
      ...loginRoutes,
      {
        element: <AppLayout />,
        children: [
          {
            path: ROUTES.DASHBOARD,
            element: <Dashboard />,
          },
          {
            path: ROUTES.DOCUMENTS,
            element: <Documents />,
          },
          {
            path: ROUTES.SHIELD,
            element: <Shield />,
          },
          {
            path: ROUTES.FRESHDESK_TICKETS,
            element: <Tickets />,
          },
          {
            path: ROUTES.SETTINGS,
            element: <Settings />,
          },
          ...accessManagerRoutes,
          ...perimeterRoutes,
          {
            path: "*",
            element: <ErrorNotFound />,
          },
        ],
      },
    ],
  },
];

const prefix = import.meta.env.VITE_APP_FRONT_URL_PREFIX;

const browserRouter = createBrowserRouter(routerConfig, {
  // Trailing slash so the "/" route resolves to `/ecms/` (inside the MSW scope).
  basename: prefix ? `${prefix.replace(/\/$/, "")}/` : undefined,
});

export const Router: FC = () => <RouterProvider router={browserRouter} />;
